const DOCUMENT_TITLE = {
  base: 'The500 Admin Panel',
  login: 'Log in — The500 Admin Panel',
  newPassword: 'Set a new password — The500 Admin Panel',
  register: 'Create your account — The500 Admin Panel',
  twoFactor: 'Two-step verification — The500 Admin Panel',
  twoFactorSetup: 'Set up two-step verification — The500 Admin Panel',
} as const;

const ERROR_PAGE_COPY = {
  eyebrow: '500 · Something broke',
  headline: 'This screen could not be loaded',
  retry: 'Try again',
} as const;

const NOT_FOUND_COPY = {
  eyebrow: '404 · Not found',
  headline: 'This screen does not exist',
  backToHome: 'Back to Home',
} as const;

export {
  DOCUMENT_TITLE,
  ERROR_PAGE_COPY,
  NOT_FOUND_COPY,
};
